import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

const LegendItem = ({ color, label, tooltip, border }: { color: string; label: string; tooltip?: string; border?: string }) => (
  <Tooltip title={tooltip ?? ''} arrow disableHoverListener={!tooltip}>
    <Box
      sx={{
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        backgroundColor: color,
        border: border ?? 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 60,
        cursor: tooltip ? 'help' : 'default',
      }}
    >
      <Typography variant='caption' sx={{ color: 'black', fontWeight: 500 }}>
        {label}
      </Typography>
    </Box>
  </Tooltip>
);

export default LegendItem;
